var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 72,
    viewBox: "0 0 162 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92434 58.7797C-3.41012 37.6532 6.55285 14.4855 23.658 11.202C33.686 5.96057 94.7474 6.55851 124.519 1.95065C154.29 -2.65721 141.535 37.4812 153.947 47.6451C163.877 55.7762 161.282 68.7725 156.084 70.2131C156.927 66.9023 149.039 50.9489 112.267 54.0961C75.4949 57.2432 11.2588 79.9063 3.92434 58.7797Z",
    stroke: "#487E6F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.6365e8ff22c44fbd6be18aace8b128db.svg";
export { ForwardRef as ReactComponent };